var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"shadow-sm",attrs:{"header-bg-variant":"secondary","header-text-variant":"white","header":"Termômetros de concreto"}},[_c('swx-table',{ref:"table",attrs:{"settings":_vm.settings}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }